<template>
  <validation-provider
    v-slot="{ errors, valid }"
    :name="question.title"
    :rules="validationRules"
    slim
  >
    <e-input
      :value="value"
      :label="question.title"
      :description="question.description"
      :type="getType()"
      :error-messages="errors"
      :success="valid"
      :is-required="validationRules.required"
      :help-id="helpObject.id"
      :help-function="() => $store.commit('setHelpObject', helpObject)"
      @input="$emit('update', { propertyName: question.propertyName, value: $event })"
    />
  </validation-provider>
</template>

<script>
export default {
  name: 'DynamicInput',

  props: {
    question: {
      type: Object,
      default: () => ({})
    },

    value: {
      type: String,
      default: ''
    },

    validationRules: {
      type: Object,
      default: () => ({})
    },

    helpObject: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ['update'],

  methods: {
    getType () {
      return {
        numberInput: 'number',
        textInput: 'text'
      }[this.question.type]
    }
  }
}
</script>

<style scoped lang="scss">
.title {
  font-weight: 400;
}
</style>
